import { useMutation, useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { Associate } from '../../../types/associates';
import { AcademiaResponse } from '../../../types/common';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useAssociateRequestActions = (
  whichAction: 'getRequestList' | '',
  associateId?: number
) => {
  // query function to fetch all the requests from database declared here
  const getRequestListHandler = useQuery({
    queryKey: ['associate-request-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<Associate>>> => {
      const response = await getPrivateAxiosInstance('user').get(
        '/registration/request/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'getRequestList'),
  });

  // mutation function to create associate status declared here
  const createAssociateStatusHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: {
        user: number;
        reviewed_by: string;
        status: 'rejected' | 'approved';
        comments: string;
        created_by: string;
      };
    }): Promise<AcademiaResponse<Associate>> => {
      const response = await getPrivateAxiosInstance('user').post(
        `/registration/request/create/`,
        body
      );

      return response.data;
    },
  });

  // mutation function to update (approve/reject) associate declared here
  const updateAssociateStatusHandler = useMutation({
    mutationFn: async ({
      associateId,
      body,
    }: {
      associateId: number;
      body: {
        user: number;
        reviewed_by: string;
        status: 'rejected' | 'approved' | 'resubmit';
        comments: string;
        is_resubmit: boolean;
        updated_by: string;
      };
    }): Promise<AcademiaResponse<Associate>> => {
      const response = await getPrivateAxiosInstance('user').patch(
        `/registration/request/${associateId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  // mutation function to update (approve/reject) associate declared here
  const updateAssociateViewStatusHandler = useMutation({
    mutationFn: async ({
      associateId,
      body,
    }: {
      associateId: number;
      body: {
        is_view: boolean;
        updated_by: string;
      };
    }): Promise<AcademiaResponse<Associate>> => {
      const response = await getPrivateAxiosInstance('user').patch(
        `/registration/request/${associateId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  return {
    getRequestListHandler,
    createAssociateStatusHandler,
    updateAssociateStatusHandler,
    updateAssociateViewStatusHandler,
  };
};

export default useAssociateRequestActions;
